import React from 'react';
import { ClassCard as Container, ClassCardContent, TinyAvatar, DarkOverlay } from '../Rows/ClassRow/style';
import { config } from '../../../Configurations';
import { Row } from '../../Layouts';
import { Text } from '../../UI/Text';
import { getFormattedDateFromTimestamp } from '../../../Utils/timeConvertorHelper';
import { timeFormats } from '../../../Constants/timeFormats';

export const ClassCard = ({ mediumImage, start, end, name, personalTrainer, spacesLeft, isSelected }) => {
    return (
        <Container isSelected={isSelected} image={`${config.baseUrl}/${mediumImage}`}>
            <DarkOverlay />
            <ClassCardContent>
                <Row width={'100%'} justify={'flex-end'}>
                    <div>
                        <Text fontSize={10} opacity={0.8} weight={'bold'}>
                            {getFormattedDateFromTimestamp(start, timeFormats.INCOMPLETE_TIME)} -{' '}
                            {getFormattedDateFromTimestamp(end, timeFormats.INCOMPLETE_TIME)}
                        </Text>
                        <Text marginTop="5px" fontSize={10} opacity={0.8} weight={'bold'}>
                            {getFormattedDateFromTimestamp(start, timeFormats.FULL_DAY_NAME)}
                        </Text>
                    </div>
                </Row>
                <div style={{ zIndex: '1' }}>
                    <Text weight={'bold'} marginBottom={'3px'} fontSize={22}>
                        {name}
                    </Text>
                    {personalTrainer && (
                        <Row>
                            <TinyAvatar image={`${config.baseUrl}/${personalTrainer.smallImage}`} />
                            <Text fontSize={13} weight={200} marginLeft={'10px'}>
                                {personalTrainer.fullName}
                            </Text>
                        </Row>
                    )}
                </div>
                <div style={{ zIndex: '1' }}>
                    <Row align={'center'}>
                        <Text fontSize={14} weight={'bold'}>
                            {spacesLeft}
                        </Text>
                        <Text fontSize={9} opacity={0.59} marginLeft={'8px'}>
                            Spaces left
                        </Text>
                    </Row>
                </div>
            </ClassCardContent>
        </Container>
    );
};



// WEBPACK FOOTER //
// ./src/UI/Components/ClassCard/index.js